import * as Actions from '../actions';
import * as moment from 'moment';
import _ from 'lodash';

const initialState = {
    course: {
        company_calendar_course_id: 0,
        course_id: 0,
        StartDate: '',
        EndDate: '',
        Unscheduled: 0,
        CourseName: '',
        Color: '#DDDDDD',
        Instructors: [
            { FullName: 'No Instructor' }
        ],
        unscheduledTotalEvents: 0,
        StudentCount: 0,
        EventsPassed: 0,
        Assets: [],
        Notifications: []
    },
    courseSchedule: [],
    Gradebook: [],
    EventsToGrade: [],
    events: [],
    loaded: false
};

const instructorCourseReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_INSTRUCTOR_COURSE_INFO):
            {
                return {
                    ...state,
                    course: {
                        ...state.course,
                        ...action.payload
                    }
                }
            }
        case (Actions.UPDATE_INSTRUCTOR_PAGE_LOADED):
            {
                return {
                    ...state,
                    loaded: action.payload
                }
            }
        case (Actions.GET_INSTRUCTOR_COURSE_EVENTS):
            {   
                let eventsToGrade
                let unscheduledTotalEvents = 0;
                if (action.payload.unscheduled === '1') {
                    eventsToGrade = action.payload.courseData.map(l => {
                        return l.EventList.map(e => {
                            return e.StudentSubmissions.filter(s => s.IsGraded === 0 && s.Submitted)
                        })
                    })
                    const eventArray = action.payload.courseData.map(l => {
                        return l.EventList.map(e => {
                            return e
                        })
                    })
    
                    const flattenedArray = _.flattenDeep(eventArray)
                    unscheduledTotalEvents = flattenedArray.length;
                }
                
                else {
                    eventsToGrade = action.payload.courseData.map(e => {
                        return e.StudentSubmissions.filter(s => s.IsGraded === 0)
                    })
                }

                return {
                    ...state,
                    course: {
                        ...state.course,
                        unscheduledTotalEvents: unscheduledTotalEvents
                    },
                    EventsToGrade: _.flattenDeep(eventsToGrade),
                    events: action.payload.courseData.map(e => {
                        return {
                            ...e,
                            start: new Date(e.StartTime),
                            end: new Date(e.EndTime),
                            title: e.EventName,
                            Unscheduled: moment(e.StartTime).format('H') === '0' && moment(e.EndTime).format('H') === '0' ? 1 : 0
                        }
                    })
                }
            }
        case (Actions.GET_INSTRUCTOR_DASHBOARD_GRADEBOOK):
            {
                return {
                    ...state,
                    Gradebook: action.payload
                }
            }
        case (Actions.GET_INSTRUCTOR_COURSE_NOTIFICATIONS):
            {
                return {
                    ...state,
                    course: {
                        ...state.course,
                        Notifications: action.payload
                    }
                }
            }
        case (Actions.RESET_INSTRUCTOR_COURSE_DASHBOARD):
            {
                return {
                    ...initialState
                }
            }
        default:
            {
                return state;
            }
    }
}

export default instructorCourseReducer;


// WEBPACK FOOTER //
// src/main/content/dashboard/store/reducers/instructorCourse.reducer.js